<script setup lang="ts">
interface ItemsObj {
  [key: string]: any
}

type CarouselProps = {
  swiperProps?: ItemsObj
  items?: Array<any>
  slideClasses?: string
  slideProps?: ItemsObj
  theme?: string
}

import { Swiper, SwiperSlide } from "swiper/vue"
import "swiper/scss"
import "swiper/scss/navigation"
import "swiper/scss/pagination"
import "swiper/scss/a11y"
import "swiper/scss/thumbs"

defineProps<CarouselProps>()
</script>

<template>
  <Swiper
    v-bind="swiperProps"
    class="app-carousel w-full"
    :class="theme ? `swiper-color-${swiperProps.theme}` : ''"
  >
    <template v-for="(item, index) in items" :key="item.id || index">
      <SwiperSlide
        v-bind="slideProps"
        v-slot="{ isActive, isPrev, isNext, isVisible, isDuplicate }"
        :class="`${slideClasses}`"
      >
        <slot
          :is-active="isActive"
          :is-prev="isPrev"
          :is-next="isNext"
          :is-visible="isVisible"
          :is-duplicate="isDuplicate"
          :item="item"
          :slideIndex="index"
        />
      </SwiperSlide>
    </template>

    <slot name="global" />
  </Swiper>
  <!-- {{ swiperProps }} -->
</template>

<style lang="scss"></style>
